// `?var=<resourceId>/<url-encoded name>` (spec 6.10.15): links to one variable of the Variables window.

const RESOURCE_ID = /^[a-z][a-z0-9-]{0,29}$/;

export interface VariableRef {
  resourceId: string;
  name: string;
}

/**
 * Parses the (already URL-decoded) query value. It is split at the first `/`, because names can be JSON
 * Pointers such as `/registry/password`. Invalid values give null.
 */
export function parseVarParam(value: string | null | undefined): VariableRef | null {
  if (!value) return null;
  const slash = value.indexOf('/');
  if (slash <= 0) return null;
  const resourceId = value.slice(0, slash);
  const name = value.slice(slash + 1);
  if (!RESOURCE_ID.test(resourceId) || name.length === 0 || name.length > 512) return null;
  return { resourceId, name };
}

/** The query value for a variable: the name is URL-encoded (so its slashes survive any decoding). */
export function formatVarParam(ref: VariableRef): string {
  return `${ref.resourceId}/${encodeURIComponent(ref.name)}`;
}

/** A link to a variable on a page: `<path>?…&var=<resourceId>/<encoded name>`. */
export function variableHref(path: string, ref: VariableRef, query: Record<string, string> = {}): string {
  const params = Object.entries(query).map(([key, value]) => `${key}=${encodeURIComponent(value)}`);
  params.push(`var=${formatVarParam(ref)}`);
  return `${path}?${params.join('&')}`;
}
